import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { CmsService } from 'src/app/services/cms.service';

@Component({
  selector: 'app-input-selector',
  templateUrl: './input-selector.component.html',
  styleUrls: ['./input-selector.component.scss']
})
export class InputSelectorComponent implements OnInit {
  @Input() public type: string;
  @Input() public min: number;
  @Input() public max: number;
  @Input() public value: string | Date;
  @Input() public deletable = false;

  @Output() public update = new EventEmitter<string | Date>();

  public editing = false;
  public model: string;

  public get stringValue() {
    if (this.value == null || this.value == '') {
      return '-';
    } else if (this.type == 'date') {
      return this.parseDate(this.value).toLocaleDateString(this.cms.language, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } else {
      return this.value;
    }
  }

  constructor(private cms: CmsService) {}

  public ngOnInit() {
    this.resetModel();
  }

  public onEdit() {
    this.editing = true;
  }

  public onCancel() {
    this.editing = false;
    this.resetModel();
  }

  public onUpdate() {
    this.applyModel();
    this.editing = false;
    this.update.emit(this.value);
  }

  public onDelete() {
    this.value = null;
    this.model = null;
    this.editing = false;
    this.update.emit(null);
  }

  private resetModel() {
    if (this.value == null) {
      this.model = null;
    } else if (this.value instanceof Date) {
      this.model = this.value.toISOString();
    } else {
      this.model = this.value;
    }
  }

  private applyModel() {
    if (this.model == null) {
      this.value = null;
    } else if (this.type == 'date') {
      this.value = new Date(this.model);
    } else {
      this.value = this.model;
    }
  }

  private parseDate(param: number | string | Date): Date {
    if (param == null || param === '') {
      return null;
    } else if (param instanceof Date) {
      return param;
    } else if (typeof param === 'number') {
      return new Date(+param * 1000);
    } else {
      return new Date(param);
    }
  }
}
